import slice from "./mapsSlice";

export default slice.reducer;
